import { pipe } from 'core/utilities';

import type { RequestAction } from '../request.d';

import { checkMissingParams } from './check-missing-params';
import { getHeaders } from './get-headers';
import { getParams } from './get-params';
import { getUrl } from './get-url';

export function getFetchParams(action: RequestAction) {
  return pipe([checkMissingParams, getHeaders, getParams, getUrl])(action);
}
